import Group from '../entities/Group';
import Wiki from '../entities/Wiki';

const readWikisByGroup = (group: Group) => ({
  type: 'READ_WIKIS_BY_GROUP',
  group
});

const successReadWikisByGroup = (wikis: Wiki[]) => ({
  type: 'SUCCESS_READ_WIKIS_BY_GROUP',
  wikis
});

const readWikisDiff = () => ({
  type: 'READ_WIKIS_DIFF'
});

const successReadWikisDiff = (wikis: Wiki[]) => ({
  type: 'SUCCESS_READ_WIKIS_DIFF',
  wikis
});

const createWiki = (wiki: Wiki) => ({
  type: 'CREATE_WIKI',
  wiki
});

const successCreateWiki = (wiki: Wiki) => ({
  type: 'SUCCESS_CREATE_WIKI',
  wiki
});

const updateWiki = (wiki: Wiki) => ({
  type: 'UPDATE_WIKI',
  wiki
});

const successUpdateWiki = (wiki: Wiki) => ({
  type: 'SUCCESS_UPDATE_WIKI',
  wiki
});

const destroyWiki = (wiki: Wiki) => ({
  type: 'DESTROY_WIKI',
  wiki
});

const successDestroyWiki = (wiki: Wiki) => ({
  type: 'SUCCESS_DESTROY_WIKI',
  wiki
});

export {
  readWikisByGroup,
  successReadWikisByGroup,
  readWikisDiff,
  successReadWikisDiff,
  updateWiki,
  successUpdateWiki,
  destroyWiki,
  successDestroyWiki,
  createWiki,
  successCreateWiki
};



// WEBPACK FOOTER //
// ./src/actions/wiki.ts